export const EMAIL_VALIDATION_MESSAGE =
  'Ingresa un correo electrónico válido; usa caracteres sin acentos ni ñ.';

const ASCII_EMAIL_PATTERN =
  /^[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?$/i;

export const normalizeEmailInput = (email?: string): string =>
  email?.trim().toLowerCase() ?? '';

export const validateAsciiEmail = (_rule: unknown, email?: string) => {
  if (!email || ASCII_EMAIL_PATTERN.test(email)) {
    return Promise.resolve();
  }

  return Promise.reject(new Error(EMAIL_VALIDATION_MESSAGE));
};
